import { useEffect } from "react";

import { isLoggedIn } from "@shapr3d/frontend-lib";
import { Navigate } from "react-router-dom";

import ConfirmEmailChange from "../components/ConfirmEmailChange/ConfirmEmailChange";
import useNavigation from "../hooks/navigation";
import useUrlHelper from "../hooks/urlHelper";
import { useMutateEmailChangeConfirm } from "../hooks/useAccount";
import type { UserError } from "../hooks/useAccountTypes";

const ChangeEmailComponent = () => {
  const urlHelper = useUrlHelper();
  const queryParams = urlHelper.getQueryParams();
  const navigation = useNavigation();

  const { mutate: confirmEmailChange, status, error, data } = useMutateEmailChangeConfirm();

  // confirms the hash if it is present in the query string
  useEffect(() => {
    if (queryParams.hash) {
      const hash = Array.isArray(queryParams.hash) ? queryParams.hash[0] : queryParams.hash;
      confirmEmailChange(hash);
    }
  }, [queryParams.hash, confirmEmailChange]);

  const loadForm = () => {
    navigation.goToProfile();
  };

  if (queryParams.hash) {
    return (
      <ConfirmEmailChange
        state={status}
        requestError={error as UserError}
        requestNewChange={loadForm}
        isLoggedIn={isLoggedIn()}
        newEmail={data?.newEmail}
      />
    );
  } else {
    return <Navigate to="/account" />;
  }
};

const ChangeEmailContainer = ChangeEmailComponent;

export default ChangeEmailContainer;
